import type { FaireProductEntity } from "../../entity_types/product";

export const p_xewqp98nk4: FaireProductEntity = {
  token: "p_xewqp98nk4",
  type: "product",
  name: "Glossy Ball 18K Gold Plated Stainless Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/2c58e12cd4f56a2a8cd293154e06873beea08e157d7f95c9dbdc0c06b4ced8bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce691fa95c3b4b6a52df7e0aca09cf515a18b470f72eae398412c0652e9c3e8c.jpeg",
    "https://cdn.faire.com/fastly/a75593dd4321b1c5a3ff9e9fd8daf3135324532dd4567e60f63bc84592e6e9c4.jpeg",
    "https://cdn.faire.com/fastly/bb639a6d73da0a03443be930ae90c025a576f90981d2a89b31e7f62e22d61077.jpeg"
  ],
  priceDollars: 4.64,
  description: "Type: Ring\nMaterial : Stainless steel ,18K gold plated\nSize : Please refer to Size chart of rings\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts \n",
  tags: [],
  msrpDollars: 11.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:52.993Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
